// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6f82199b","225":"62b742bd","787":"a1fbcab3","911":"10ef3654"}[chunkId] + ".chunk.js";
};